import styled from "@emotion/styled";

export const ButtonCloseWorkAround = styled.div(_ => ({
    position: "absolute",
    left: "-6px",
}));
